import { apiClient } from "./client";
import type { AuthResponse, UserProfile, TokenBalance } from "@stellex-tycoon/shared-types";

export async function authWithTelegram(initData: string): Promise<AuthResponse> {
  const { data } = await apiClient.post<AuthResponse>("/auth/telegram", { initData });
  return data;
}

export async function fetchMe(): Promise<UserProfile> {
  const { data } = await apiClient.get<UserProfile>("/me");
  return data;
}

export async function fetchBalance(): Promise<TokenBalance> {
  const { data } = await apiClient.get<TokenBalance>("/me/balance");
  return data;
}

export async function logout(): Promise<void> {
  await apiClient.post("/auth/logout");
}

/** Player-chosen public handle. Required before any scene renders — gated
 * by the username modal in App.tsx. Server validates format + uniqueness;
 * UI mirrors the format check so the user gets instant feedback. */
export async function setDisplayName(displayName: string): Promise<UserProfile> {
  const { data } = await apiClient.put<UserProfile>("/me/display-name", { displayName });
  return data;
}
